import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=37040ef4&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=37040ef4&prod&scoped=true&lang=css"
import style1 from "./Search.vue?vue&type=style&index=1&id=37040ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37040ef4",
  null
  
)

export default component.exports